<app-page>
  <app-page-title [title]="'STRUCTURE.OVERVIEW.TITLE' | translate">
    <dx-button
      *ngIf="!isManager"
      class="cta-btn"
      type="default"
      [text]="'COMMON.DELETE' | translate"
      [disabled]="selectedOrganisationUnits.length < 1 || isDeleteDisabled()"
      (click)="onDeleteClick()"
    ></dx-button>
    <dx-button
      *ngIf="!isManager"
      class="cta-btn"
      type="normal"
      icon="add"
      [text]="'STRUCTURE.OVERVIEW.ADD-ORGANIZATION-UNIT' | translate"
      [disabled]="selectedOrganisationUnits.length !== 1"
      (click)="onAddClick()"
    ></dx-button>
  </app-page-title>
  <dx-tree-list
    class="organisation-units-tree-list"
    *ngIf="organisationUnits && organisationUnits.length"
    [dataSource]="organisationUnits"
    [rootValue]="null"
    keyExpr="id"
    parentIdExpr="parentId"
    [showBorders]="false"
    [showColumnLines]="false"
    [showRowLines]="true"
    [columnAutoWidth]="true"
    [allowColumnResizing]="true"
    [columnResizingMode]="'nextColumn'"
    [expandedRowKeys]="[1]"
    (onSelectionChanged)="onUnitsSelectionChanged($event)"
    [expandedRowKeys]="[organisationUnits[0].id]"
    [scrolling]="{ mode: 'standard' }"
    (onNodesInitialized)="onOrganisationUnitsInitialized($event)"
    [selection]="{
      mode: selectionMode,
      recursive: false,
      allowSelectAll: false
    }"
  >
    <!-- <dxo-selection mode="multiple" [recursive]="true"></dxo-selection> -->
    <dxo-search-panel
      [visible]="true"
      [width]="250"
      [placeholder]="'COMMON.SEARCH' | translate"
    ></dxo-search-panel>
    <dxo-state-storing
      [enabled]="true"
      type="custom"
      [customLoad]="loadGridState"
      [customSave]="saveGridState">
    </dxo-state-storing>
    <dxi-column
      dataField="name"
      [caption]="'COMMON.FIELDS.NAME' | translate"
      alignment="left"
      width="600"
    ></dxi-column>
    <dxi-column
      dataField="type"
      [caption]="'COMMON.FIELDS.TYPE' | translate"
      cellTemplate="typeCellTemplate"
      alignment="left"
    ></dxi-column>
    <dxi-column
      dataField="description"
      [caption]="'COMMON.FIELDS.DESCRIPTION' | translate"
      alignment="left"
      cssClass="description-column"
    ></dxi-column>
    <dxi-column
      *ngIf="!isManager"
      caption=""
      dataField="this"
      cellTemplate="actionsTemplate"
      width="70px"
      alignment="left"
    ></dxi-column>
    <div *dxTemplate="let data of 'typeCellTemplate'">
      <span *ngIf="data.value == OrganisationUnitTypeModel.Department">{{
        "COMMON.FIELDS.DEPARTMENT" | translate
      }}</span>
      <span *ngIf="data.value == OrganisationUnitTypeModel.Location">{{
        "COMMON.FIELDS.LOCATION" | translate
      }}</span>
    </div>
    <div *dxTemplate="let data of 'actionsTemplate'">
      <dx-button
        class="edit-button"
        type="default"
        [icon]="editIcon"
        (click)="onEditClick(data.value.id)"
      >
      </dx-button>
    </div>
  </dx-tree-list>
</app-page>

<app-confirmation-dialog
  [height]="'auto'"
  [(showModal)]="showEmployeesExistsModal"
  (submit)="onRemoveOragisationUnitConfirm()"
  [options]="modalEmployeesExistsOptions"
  [hideDismissButton]="true"
></app-confirmation-dialog>

<app-confirmation-dialog
  [height]="'auto'"
  [(showModal)]="showDeleteOragisationUnitModal"
  (submit)="confirmOrganisationUnitDeletion(unitsToDelete)"
  [options]="modalConfirmationOptions"
></app-confirmation-dialog>
